export const VIEW_CONFIGS_PROVIDER_TOKEN = 'VIEW_CONFIGS_PROVIDER';
export interface IViewConfigsProvider {
  getViewDimensions(): { width: string; height: string };
}
